import React from 'react';
import { Info, Github, Mail, ExternalLink, Zap, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <div className="bg-blue-600 rounded-full p-2 mr-2">
                <Zap className="h-5 w-5 text-white" />
              </div>
              <h3 className="text-xl font-bold">Stromkalkulator.no</h3>
            </div>
            <p className="text-gray-300 text-sm">
              Din guide til strømpriser i Norge. Sammenlign priser, beregn kostnader og få innsikt i strømmarkedet.
            </p>
          </div>

          <div>
            <h4 className="font-medium text-lg mb-4">Verktøy</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <Zap className="h-4 w-4 mr-2" />
                  <span>Strømpriser i dag</span>
                </Link>
              </li>
              <li>
                <Link to="/norgespris" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <Zap className="h-4 w-4 mr-2" />
                  <span>Norgespris kalkulator</span>
                </Link>
              </li>
              <li>
                <Link to="/sammenlign-leverandorer" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <Zap className="h-4 w-4 mr-2" />
                  <span>Sammenlign strømleverandører</span>
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <BookOpen className="h-4 w-4 mr-2" />
                  <span>Strømblogg og tips</span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-lg mb-4">Informasjon</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/personvernerklaering" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>Personvernerklæring</span>
                </Link>
              </li>
              <li>
                <Link to="/bruksvilkar" className="text-gray-300 hover:text-white text-sm flex items-center">
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>Bruksvilkår</span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-lg mb-4">Nyttige lenker</h4>
            <ul className="space-y-2">
              <li>
                <a href="https://www.regjeringen.no/no/tema/energi/regjeringens-stromtiltak/id2900232/" className="text-gray-300 hover:text-white text-sm flex items-center" target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>Strømstøtteordningen</span>
                </a>
              </li>
              <li>
                <a href="https://www.nordpoolgroup.com/en/Market-data1/Dayahead/Area-Prices/NO/Daily/?view=table" className="text-gray-300 hover:text-white text-sm flex items-center" target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>Nord Pool spotpriser</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.vikse.dev/" 
                  className="text-gray-300 hover:text-white text-sm flex items-center"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ExternalLink className="h-4 w-4 mr-2" />
                  <span>vikse.dev</span>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-lg mb-4">Kontakt</h4>
            <div className="flex items-center mb-2">
              <Mail className="h-4 w-4 mr-2 text-gray-300" />
              <a href="mailto:kontakt@stromkalkulator.no" className="text-gray-300 hover:text-white text-sm">
                tor.jetix16@gmail.com
              </a>
            </div>
            <p className="text-sm text-gray-400 mt-4">
              Meld deg på vårt nyhetsbrev for å motta oppdateringer om strømpriser og energisparing.
            </p>
            <div className="mt-2 flex">
              <input 
                type="email" 
                placeholder="Din e-post" 
                className="bg-gray-700 text-white px-3 py-1 text-sm rounded-l outline-none border border-gray-600 focus:border-blue-500"
              />
              <button className="bg-blue-600 text-white px-3 py-1 text-sm rounded-r">
                Meld på
              </button>
            </div>
          </div> 

        </div>

        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <div className="flex flex-col items-center space-y-2">
            <p className="text-xs text-gray-400">
              &copy; {new Date().getFullYear()} Stromkalkulator.no. Data fra HvaKosterStrømmen.no.
            </p>
            <p className="text-xs text-gray-400">
              Laget med <span className="text-red-500">❤</span> fra{' '}
              <a 
                href="https://vikse.dev" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-blue-400 hover:text-blue-300 transition-colors"
              >
                VIKSE
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;